module.exports = __webpack_public_path__ + "img/partner01.ecb32a6e.png";